import React, { useState } from 'react';

import { Button, Typography } from '@mui/material';

import './PurchasedSubscriptionCell.scss';
import { format } from 'date-fns';
import _ from 'lodash';

import { useGetMeMutation } from '../../../../common/apis/CommonApi';
import { useCancelStripeSubscriptionMutation } from '../../../../common/apis/FlorenceApi';
import { useAppSelector } from '../../../../common/hooks/reduxHooks';
import { AVAILABLE_SUBSCRIPTIONS } from '../../../constants/Purchases';
import UnsubscribeConfirmationModal from '../Modals/UnsubscribeConfirmationModal';
import UnsubscribeMobileModal from '../Modals/UnsubscribeMobileModal';
import UnsubscribeSuccessfullyModal from '../Modals/UnsubscribeSuccessfullyModal';

const PurchasedSubscriptionCell: React.FC = () => {
  const [cancelStripeSubscription] = useCancelStripeSubscriptionMutation();
  const [getMeMutation] = useGetMeMutation();
  const { user } = useAppSelector((state) => state.model);
  const [unsubscribeConfirmationModal, setUnsubscribeConfirmationModal] =
    useState(false);
  const [unsubscribeMobileModal, setUnsubscribeMobileModal] = useState(false);
  const [unsubscribeDoneModal, setUnsubscribeDoneModal] = useState(false);
  const [loadingUnsubscribe, setLoadingUnsubscribe] = useState(false);

  const cancelActiveSubscription = () => {
    if (!user) return;
    if (user.subscriptionStore === 'stripe') {
      setUnsubscribeConfirmationModal(true);
    } else {
      setUnsubscribeMobileModal(true);
    }
  };

  const confirmUnsubscribe = async () => {
    setLoadingUnsubscribe(true);
    setUnsubscribeConfirmationModal(false);
    setUnsubscribeDoneModal(true);
    cancelStripeSubscription()
      .then(() => {
        setLoadingUnsubscribe(false);
      })
      .catch((e) => {
        setUnsubscribeDoneModal(false);
        setLoadingUnsubscribe(false);
        alert('There has been a problem. Please try again later');
      })
      .finally(() => {
        getMeMutation();
      });
  };

  return (
    <>
      {user && (
        <div className='purchased-container'>
          <div>
            <Typography
              fontWeight={600}
              color={'primary'}
              fontSize={24}
              style={{ textAlign: 'center' }}
            >
              Your current plan
            </Typography>

            {user.activeSubscriptionType && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: 8,
                  marginBottom: 16,
                }}
              >
                <div className={'bubble-container'}>
                  <Typography fontSize={18} color='white' fontWeight={500}>
                    {user?.activeSubscriptionType &&
                      _.capitalize(user.activeSubscriptionType)}
                  </Typography>
                </div>
                {user.activeSubscriptionType !== 'trial' && (
                  <Button
                    color='secondary'
                    variant='text'
                    disableElevation
                    style={{
                      borderRadius: 40,
                      paddingLeft: 16,
                      paddingRight: 16,
                      marginLeft: 12,
                    }}
                    onClick={cancelActiveSubscription}
                  >
                    <Typography fontSize={18} color='darkgray' fontWeight={500}>
                      Unsubscribe
                    </Typography>
                  </Button>
                )}
              </div>
            )}
          </div>
          <div
            style={{
              maxWidth: 480,
              marginTop: 8,
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: 'center',
            }}
          >
            {!user.activeSubscriptionType && (
              <Typography fontSize={16}>
                {/* eslint-disable-next-line react/no-unescaped-entities */}
                At the moment you don't have an active subscription.
              </Typography>
            )}

            {user.activeSubscriptionType === 'trial' && (
              <Typography fontSize={16}>
                Free trials are limited to 30 days. You can make 5 free scans.
                You are limited to seeing 5 OP notes during free trial. Unused
                note scans expire after trial expires.
              </Typography>
            )}

            {user.activeSubscriptionType &&
              user.activeSubscriptionType !== 'trial' && (
                <Typography fontSize={16}>
                  You subscribed for {_.capitalize(user.activeSubscriptionType)}{' '}
                  plan: $
                  {
                    _.find(AVAILABLE_SUBSCRIPTIONS, {
                      type: user.activeSubscriptionType,
                    })?.monthlyCost
                  }{' '}
                  monthly
                </Typography>
              )}

            {user.activeSubscriptionType && user.subscriptionExpirationDate && (
              <Typography style={{ marginTop: 8 }} fontSize={16}>
                {_.capitalize(user.activeSubscriptionType)} plan runs until{' '}
                {format(
                  new Date(user.subscriptionExpirationDate),
                  'MM-dd-yyyy'
                )}
              </Typography>
            )}
          </div>
          <UnsubscribeConfirmationModal
            open={unsubscribeConfirmationModal}
            onClose={() => setUnsubscribeConfirmationModal(false)}
            onAccept={() => confirmUnsubscribe()}
          />
          <UnsubscribeMobileModal
            open={unsubscribeMobileModal}
            platform={user.subscriptionStore}
            onClose={() => setUnsubscribeMobileModal(false)}
          />
          <UnsubscribeSuccessfullyModal
            open={unsubscribeDoneModal}
            loading={loadingUnsubscribe}
            onClose={() => setUnsubscribeDoneModal(false)}
          />
        </div>
      )}
    </>
  );
};

export default PurchasedSubscriptionCell;
